// Venue matching deliberately keeps Barcelona and Madrid separate.
export const CIRCUITS = [
  ['melbourne','Melbourne','Australia','Melbourne'], ['shanghai','Shanghai','China','Shanghai'],
  ['suzuka','Suzuka','Japan','Suzuka'], ['bahrain','Bahrain','Bahrain','Sakhir|Bahrain'],
  ['jeddah','Jeddah','Saudi Arabia','Jeddah'], ['miami','Miami','United States','Miami'],
  ['imola','Imola','Italy','Imola'], ['monaco','Monaco','Monaco','Monaco'],
  ['barcelona','Barcelona','Spain','Barcelona|Catalunya'], ['madrid','Madrid','Spain','Madrid|Madring'],
  ['montreal','Montreal','Canada','Montreal|Montréal|Gilles'], ['spielberg','Spielberg','Austria','Spielberg|Red Bull'],
  ['silverstone','Silverstone','United Kingdom','Silverstone'], ['spa','Spa-Francorchamps','Belgium','Spa'],
  ['budapest','Budapest','Hungary','Hungaroring|Budapest'], ['zandvoort','Zandvoort','Netherlands','Zandvoort'],
  ['monza','Monza','Italy','Monza'], ['baku','Baku','Azerbaijan','Baku'],
  ['singapore','Singapore','Singapore','Singapore|Marina'], ['austin','Austin','United States','Austin|Americas'],
  ['mexico-city','Mexico City','Mexico','Mexico|Hermanos'], ['sao-paulo','São Paulo','Brazil','Paulo|Interlagos'],
  ['las-vegas','Las Vegas','United States','Vegas'], ['lusail','Lusail','Qatar','Lusail|Losail'],
  ['abu-dhabi','Yas Marina','United Arab Emirates','Yas|Abu Dhabi'],
].map(([slug,name,country,aliases])=>({slug,name,country,aliases}));
export type Circuit = typeof CIRCUITS[number];
export function circuitMatches(circuit:Circuit, name:string) {
  return circuit.aliases.split('|').some(alias=>name.toLowerCase().includes(alias.toLowerCase()));
}
